<template>
  <!--  Boudewijn, maybe you can refactor this some time so that it only outputs a radialGradient for the current theme, instead of a list for all themes and only use one?-->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 791 1691" role="graphics-symbol">
    <defs>
      <linearGradient v-for="theme in themes" :id="theme.title" :key="theme.title" :x1="theme.x1" :y1="theme.y1" :x2="theme.x2" :gradientTransform="theme.gradientTransform">
        <stop offset="0" :stop-color="theme.startColor" />
        <stop offset="1" :stop-color="theme.endColor" />
      </linearGradient>
    </defs>
    <path
      d="M324.9 763.7c109.9 107 155.4 187.4 243.8 355.6.5.9 1 1.8 1.4 2.7.1.1.1.2.2.3l-.1-.1c-.4-.2-.9-.5-1.3-.8-12.5-7.2-33.5-12.7-68.4-12.7-160.6 0-290.8 130.3-290.8 291.2 0 160.8 130.2 291 290.6 291 160.4 0 290.8-130.3 290.8-291.2V0H0c0 316 153.4 596.7 324.9 763.7z"
      :fill="`url(#${svgTheme})`"
    />
  </svg>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import { appColors } from '~/assets/tailwind'

defineProps({
  svgTheme: {
    type: String as PropType<string>,
    required: false,
    default: '',
    validator: (value: string) => ['petrol', 'dark-green', 'peach', 'red', 'ocher-yellow', 'blue', 'pink', 'purple', 'purple-mobile', 'light-blue'].includes(value),
  },
})

const themes = [
  {
    title: 'petrol',
    startColor: appColors['secondary-9-blue--turquoise'],
    endColor: appColors['secondary-9-blue--iris'],
    x1: '11.12%',
    y1: '0%',
    x2: '52.48%',
    gradientTransform: 'rotate(-30)',
  },
  {
    title: 'dark-green',
    startColor: appColors['secondary-9-green--sherpa-blue'],
    endColor: appColors['secondary-8-blue--medium-aquamarine'],
    x1: '11.12%',
    y1: '0%',
    x2: '52.48%',
    gradientTransform: 'rotate(-30)',
  },
  {
    title: 'peach',
    startColor: appColors['secondary-3-orange--atomic-tangerine'],
    endColor: appColors['secondary-6-red--azalea'],
    x1: '12.98%',
    y1: '0%',
    x2: '46.88%',
    gradientTransform: 'rotate(-29)',
  },
  {
    title: 'red',
    startColor: appColors['primary-1-red--torch'],
    endColor: appColors['primary-1-red--fire-brick'],
    x1: '19.19%',
    y1: '0%',
    x2: '45.32%',
    gradientTransform: 'rotate(-10)',
  },
  {
    title: 'ocher-yellow',
    startColor: appColors['secondary-2-yellow--saffron'],
    endColor: appColors['secondary-2-yellow--dark-portica'],
    x1: '19.19%',
    y1: '0%',
    x2: '52.48%',
    gradientTransform: 'rotate(-30)',
  },
  {
    title: 'blue',
    startColor: appColors['secondary-5-blue--onahau'],
    endColor: appColors['secondary-5-blue--prussian'],
    x1: '11.12%',
    y1: '0%',
    x2: '52.48%',
    gradientTransform: 'rotate(-30)',
  },
  {
    title: 'pink',
    startColor: appColors['secondary-6-red--azalea'],
    endColor: appColors['secondary-6-red--french-rose'],
    x1: '11.12%',
    y1: '0%',
    x2: '52.48%',
    gradientTransform: 'rotate(-30)',
  },
  {
    title: 'purple',
    startColor: appColors['secondary-7-violet--fog'],
    endColor: appColors['secondary-7-violet--purple-heart'],
    x1: '11.12%',
    y1: '0%',
    x2: '52.48%',
    gradientTransform: 'rotate(-10)',
  },
  {
    title: 'purple-mobile',
    startColor: appColors['secondary-7-violet--purple-heart'],
    endColor: appColors['secondary-7-violet--purple-heart'],
    x1: '0%',
    y1: '0%',
    x2: '100%',
    gradientTransform: 'rotate(-10)',
  },
  {
    title: 'light-blue',
    startColor: appColors['secondary-10-blue--bright-sky'],
    endColor: appColors['secondary-10-blue--royal-blue'],
    x1: '11.12%',
    y1: '0%',
    x2: '52.48%',
    gradientTransform: 'rotate(-30)',
  },
]
</script>
